import cn from 'classnames';
import { FC } from 'react';

import styles from './ModalBody.module.scss';

interface IModalBodyProps {
  border?: 'bottom';
  size?: 'content';
  overflow?: 'scroll';
  padding?: 'small';
}

export const ModalBody: FC<IModalBodyProps> = ({ children, border, size, overflow, padding }) => {
  return (
    <div
      className={cn(styles.Body, {
        [styles.BodyBorderBottom]: border === 'bottom',
        [styles.BodyPaddingSmall]: padding === 'small',
        [styles.BodySizeContent]: size === 'content',
        [styles.BodyScroll]: overflow === 'scroll',
      })}
    >
      {children}
    </div>
  );
};
